export default "__VITE_ASSET__DOAGZ0yW__"